.root {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 12px 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 13px;
}
.empty {
  margin: 0;
  color: var(--ink-faint);
  font-style: italic;
}
